import * as angular from 'angular';

class PanelLoadingController {}

export const PanelLoadingComponent: angular.IComponentOptions = {
  controller: PanelLoadingController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <br />
    <br />
    <br />
    <mode-loader></mode-loader>
  `,
};
